const prefix = 'residentservice360.proposal-draft.v1.';
const accountPrefix = userId => `${prefix}${encodeURIComponent(userId)}.`;
const keyFor = (userId, scope) => `${accountPrefix(userId)}${encodeURIComponent(scope)}`;
const browserStorage = () => { try { return globalThis.sessionStorage; } catch { return null; } };

export function loadProposalDraft(userId, scope, storage = browserStorage()) {
  if (!userId) return null;
  try {
    const value = JSON.parse(storage?.getItem(keyFor(userId, scope)) || 'null');
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    return { companyId: typeof value.companyId === 'string' ? value.companyId : '',
      message: typeof value.message === 'string' ? value.message : '', price: typeof value.price === 'string' ? value.price : '',
      active: typeof value.active === 'string' ? value.active : null };
  } catch { return null; }
}
export function saveProposalDraft(userId, scope, draft, storage = browserStorage()) {
  if (!userId || !storage) return false;
  try {
    if (!draft.message && !draft.price && !draft.active) storage.removeItem(keyFor(userId, scope));
    else storage.setItem(keyFor(userId, scope), JSON.stringify(draft));
    storage.setItem(keyFor(userId, 'return-scope'), scope);
    return true;
  } catch { return false; }
}
export function proposalReturnPath(userId, storage = browserStorage()) {
  try {
    const scope = storage?.getItem(keyFor(userId, 'return-scope'));
    return { all: '/supplier/opportunities', job: '/commercial/jobs', private: '/tenders/private' }[scope] || '/supplier/opportunities';
  } catch { return '/supplier/opportunities'; }
}
export function clearProposalDrafts(userId, storage = browserStorage()) {
  if (!userId || !storage) return;
  try {
    const keys = Array.from({ length: storage.length }, (_, i) => storage.key(i));
    for (const key of keys) if (key?.startsWith(accountPrefix(userId))) storage.removeItem(key);
  } catch { /* Storage can be unavailable in private browser contexts. */ }
}
